/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * type of diffusion:
 *   * EMAIL
 *   * SMS
 *   * VOICE_CALL
 */
export enum DiffusionType {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  VOICE_CALL = 'VOICE_CALL'
}
